/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Form, Select } from 'antd';
import { OptionEntity } from 'domain/entities/OptionEntity';
import { CSSProperties } from 'react';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';

type props = {
    style?: CSSProperties;
    defaultValue?: string;
    options: OptionEntity[];
    icon?: any;
    name?: string;
    required?: boolean;
    disabled?: boolean;
    messageRequired?: string;
    onChange?: (value: string) => void;
    size?: any;
    placeholder?: string;
    className?: string;
};

const SelectionDynamic = ({
    style,
    icon,
    options,
    defaultValue,
    name,
    required,
    disabled,
    messageRequired,
    onChange,
    size,
    placeholder = PLACEHOLDER.SELECT,
    className = 'select-custom',
}: props) => {
    return (
        <Form.Item name={name} rules={[{ required: required, message: messageRequired }]}>
            <Select
                style={{ ...style }}
                size={size}
                className={`select-custom ${className ?? ''}`}
                defaultValue={defaultValue}
                options={options}
                suffixIcon={icon}
                disabled={disabled}
                placeholder={placeholder}
                onChange={onChange}
            />
        </Form.Item>
    );
};

export default SelectionDynamic;
